import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// Components
import VariantOfferBox from '../OfferBoxWithoutCtas';

// Selectors
import { isPDPDualOffer } from 'src/universal/components/PremiumHero/redux.js';
import { getPdpOfferData, getOfferBadgeText } from 'page_modules/business-pdp/redux';
import { isCardMember } from 'src/universal/redux/userType';
import { getPageLabels } from 'src/universal/redux/page';

//Styles
import styles from './__styles__/dynamicOfferBox.scss?modules';

const OfferBox = React.memo(function OfferBox({ offerData, shortName }) {
  const allowRender = !!offerData;

  return (
    <div
      className={clsx(styles.dynamicOfferWrap, {
        [styles.needToRender]: allowRender
      })}
    >
      <VariantOfferBox shortName={shortName} />
    </div>
  );
});

const mapStateToProps = state => ({
  isCardMember: isCardMember(state),
  offerData: getPdpOfferData(state),
  pageLabels: getPageLabels(state),
  isPDPDualOffer: isPDPDualOffer(state),
  offerBadgeText: getOfferBadgeText(state)
});

export const DynamicOfferBox = connect(mapStateToProps)(OfferBox);
